import { noop } from 'lodash';
import React from 'react';

export type FilterAlertsContextType = (id: string) => void;

export const FilterAlertsContext = React.createContext<FilterAlertsContextType>(noop);
